export default __webpack_public_path__ + "static/media/harvest.c7253399.gif";